import React, { useCallback, useState } from 'react';
import { ActionButton } from '../common/ActionButton';
import { Form } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { HealthDeclaration } from '../declaration/HealthDeclaration';
import { CheckinForm } from '../../service/checkin-flow';

type  DeclarationStepProps = {
    buttonText: string,
    buttonLoadingText: string,
    buttonLoading: boolean,
    onStepComplete: (form: CheckinForm) => void
}

export const DeclarationStep = ({ buttonText, buttonLoadingText, buttonLoading, onStepComplete }: DeclarationStepProps) => {
    const methods = useForm<CheckinForm>();
    const [buttonDisabled, setButtonDisabled] = useState(true);

    const onSelectionMade = useCallback(() => {
        if (buttonDisabled) {
            setButtonDisabled(false);
        }
    }, [buttonDisabled]);

    return (
            <FormProvider {...methods}>
                <Form onSubmit={methods.handleSubmit(onStepComplete)}>
                    <HealthDeclaration onSelectionMade={onSelectionMade} />
                    <ActionButton text={buttonLoading ? buttonLoadingText : buttonText}
                                  disabled={buttonDisabled || buttonLoading} submit />
                </Form>
            </FormProvider>
    )
}
